import moment from 'moment';

import { IAdminEvent } from '../store';

import api, { request } from '../../../../api';
import { IStore } from '../../../';

export const edit = async (state: IStore, clubId: number | string, event: Partial<IAdminEvent>) => {
  const body: any = {
    ...event,
    end: moment(event.end)
      .endOf('day')
      .format('YYYY-MM-DDTHH:mm:ssZ'),
    handicapMetric: event.handicapMetric ? Number(event.handicapMetric) : null,
    // season: event.season.id,
    // season: null, // is a wired var
    start: moment(event.start)
      .startOf('day')
      .format('YYYY-MM-DDTHH:mm:ssZ')
  };
  delete body.flights;
  delete body.season;
  delete body.image;
  delete body.rounds;

  const response = await request.patch(`${api.admin.events(Number(clubId))}${event.id}/`, body);

  if (response.error) {
    const err =
      (response.error.statusText && response.error.statusText.join('. ')) || response.error.status;
    return { errors: { events: { msg: 'Error updating the event: ' + err } } };
  }

  const newEvent = {
    ...event,
    ...response
  };

  return {
    adminEvents: {
      all: {
        ...state.adminEvents.all,
        [response.id]: newEvent
      },
      current: newEvent,
      [response.id]: newEvent
    }
  };
};
